import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Slider from './../Slider';

class Fb extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const row = (feed, i) => (
            <article key={i} className="fb_item">
                {(()=> {
                    if (feed.full_picture) {
                        return (
                            <a 
                                style={{
                                    backgroundImage: `url(${feed.full_picture})` }} href={`https://www.facebook.com/jorcycling/posts/${ feed.object_id }`} className="img" target="_blank">
                                <img src={feed.full_picture} alt={feed.title} />
                            </a>
                        );
                    }
                })()}
                {(()=> {
                    if (feed.message) {
                        var post_id = feed.id.replace(feed.from.id, "").replace("_", "");
                        return (
                            <p>
                                <a href={`https://www.facebook.com/jorcycling/posts/${ post_id }`}target="_blank">{ feed.message }</a>
                            </p>
                        );
                    }
                })()}
                
            </article>
        );
        return (
            <section className="fb_section">
                { this.props.data.map( (feed, i) => row(feed, i)) }
            </section>
        );
    }
}


export default class FbWigdet {
    constructor(props) {
        const { el } = props;
        this.props = props;
        if (el) {
            this.fetchData();
        }
    }

    fetchData() {
        const { atoken, fbid, el } = this.props;
        try {
            const url = `https://graph.facebook.com/${fbid}/posts?access_token=${atoken}&limit=8&fields=id,message,full_picture,link,name,description,type,icon,created_time,from,object_id`;
            axios.get(url).then( results => {
                ReactDOM.render(<Fb data={ results.data.data }/>, el);
                new Slider(el.querySelector('section'), '', 'article', {
                    dotts: true,
                    timer: true
                });
            });
            
        }catch(e) {
            console.error(e);
        }
    }
}


// WEBPACK FOOTER //
// ./modules/FbWidget/index.js